let Environment = {
    YfethContractAddress: "0x1C89f9E644aAa08Dfb762bCe95061ECFC74C37dF",
  
  };
  
  export default Environment;